import React from "react";
import { Eye, Edit2, Trash2, PackageOpen } from "lucide-react";
import { motion } from "framer-motion";
import Tooltip from "../../../components/ui/Tooltip";
import MiniLoader from "../../../components/MiniLoader";
import { Button } from "../../../components/ui/button";

export default function ProduitsTable({
  produits,
  setSelectedRows,
  setProduitSelectionne,
  setOpenFicheProduit,
  setOpenEdition,
  setOpenDeleteModal,
  userRole,
  isLoading
}) {
  if (isLoading) {
    return <MiniLoader />;
  }

  if (!produits || produits.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 bg-surface shadow-hp-sm border border-[var(--hp-color-border-muted)] rounded-lg text-subtle">
        <motion.div
          animate={{ y: [0, -10, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          className="mb-4 text-[var(--hp-info-300)]"
        >
          <PackageOpen className="w-16 h-16" />
        </motion.div>
        <p className="text-lg font-medium text-secondary">Aucun produit trouvé.</p>
        <p className="text-sm mt-1">Modifiez vos critères de recherche ou ajoutez un nouveau produit.</p>
      </div>
    );
  }

  return (
    <div className="bg-surface shadow-hp-sm border border-[var(--hp-color-border-muted)] rounded-lg overflow-x-auto">
      <table className="min-w-full divide-y divide-[var(--hp-color-border-muted)]">
        <thead className="bg-workspace">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-subtle uppercase tracking-wider">
              Code ISIN / Nom
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-subtle uppercase tracking-wider">
              Société de gestion
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-subtle uppercase tracking-wider">
              Catégorie
            </th>
            <th className="px-6 py-3 text-center text-xs font-medium text-subtle uppercase tracking-wider">
              Risque
            </th>
            <th className="px-6 py-3 text-center text-xs font-medium text-subtle uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-surface divide-y divide-[var(--hp-color-border-muted)]">
          {produits.map((p, index) => (
            <motion.tr
              key={p.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05 }}
              className="hover:bg-workspace transition-colors"
            >
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm font-bold text-primary">{p.nom_produit}</div>
                <div className="text-xs text-subtle font-mono">{p.code_isin}</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm font-medium text-secondary">{p.societe_gestion || "N/C"}</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-surface-muted text-primary border border-workspace">
                  {p.type || "N/C"}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-center">
                <span className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-[var(--hp-info-50)] text-[var(--hp-info-700)] text-sm font-bold border border-[var(--hp-info-200)]">
                  {p.risque || "-"}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                <div className="flex items-center justify-center gap-2">
                  <Tooltip content="Voir">
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => {
                        setProduitSelectionne(p);
                        setOpenFicheProduit(true);
                      }}
                      className="h-8 w-8 text-secondary hover:text-[var(--hp-info-500)] hover:bg-[var(--hp-info-50)]"
                    >
                      <Eye className="w-4 h-4" />
                    </Button>
                  </Tooltip>
                  <Tooltip content="Éditer">
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => {
                        setProduitSelectionne(p);
                        setOpenEdition(true);
                      }}
                      className="h-8 w-8 text-secondary hover:text-[var(--hp-warning-500)] hover:bg-[var(--hp-warning-50)]"
                    >
                      <Edit2 className="w-4 h-4" />
                    </Button>
                  </Tooltip>

                  {(userRole === "Associé" || userRole === "Administrateur") && (
                    <Tooltip content="Supprimer">
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => {
                          setProduitSelectionne(p);
                          setOpenDeleteModal(true);
                        }}
                        className="h-8 w-8 text-[var(--hp-danger-500)] hover:text-[var(--hp-danger-700)] hover:bg-[var(--hp-danger-50)]"
                      >
                        <Trash2 className="w-4 h-4" />
                      </Button>
                    </Tooltip>
                  )}
                </div>
              </td>
            </motion.tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
